var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "More"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 18.5492C11.7167 18.5492 11.4793 18.4492 11.288 18.2492C11.096 18.0492 11 17.8159 11 17.5492C11 17.2659 11.096 17.0282 11.288 16.8362C11.4793 16.6449 11.7167 16.5492 12 16.5492C12.2833 16.5492 12.521 16.6449 12.713 16.8362C12.9043 17.0282 13 17.2659 13 17.5492C13 17.8159 12.9043 18.0492 12.713 18.2492C12.521 18.4492 12.2833 18.5492 12 18.5492ZM12 12.9992C11.7167 12.9992 11.4793 12.9032 11.288 12.7112C11.096 12.5199 11 12.2826 11 11.9992C11 11.7159 11.096 11.4782 11.288 11.2862C11.4793 11.0949 11.7167 10.9992 12 10.9992C12.2833 10.9992 12.521 11.0949 12.713 11.2862C12.9043 11.4782 13 11.7159 13 11.9992C13 12.2826 12.9043 12.5199 12.713 12.7112C12.521 12.9032 12.2833 12.9992 12 12.9992ZM12 7.44922C11.7167 7.44922 11.4793 7.35322 11.288 7.16122C11.096 6.96989 11 6.73255 11 6.44922C11 6.18255 11.096 5.94922 11.288 5.74922C11.4793 5.54922 11.7167 5.44922 12 5.44922C12.2833 5.44922 12.521 5.54922 12.713 5.74922C12.9043 5.94922 13 6.18255 13 6.44922C13 6.73255 12.9043 6.96989 12.713 7.16122C12.521 7.35322 12.2833 7.44922 12 7.44922Z",
    fill: "#15B79E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMenuIcon);
export default __webpack_public_path__ + "static/media/more-menu-icon.a0af5861b8deee3019e3f43c644883f6.svg";
export { ForwardRef as ReactComponent };